export enum EnumTipoResultado {
  Indefinido = 0,
  Sucesso = 1,
  Info = 2,
  Alerta = 3,
  Erro = 4,
}

export enum EnumTipoMensagem {
  Indefinido = 0,
  Sucesso = 1,
  Info = 2,
  Alerta = 3,
  Erro = 4,
}

export enum EnumSizeModal {
  Indefinido = 0,
  Small = 1,
  Medium = 2,
  Large = 3,
}
